import React from "react";
import { makeStyles } from 'tss-react/mui';

// core components
import Header from "../components/Header/Header.js";
import Footer from "../components/Footer/Footer.js";
import GridContainer from "../components/Grid/GridContainer.js";
import GridItem from "../components/Grid/GridItem.js";
import HeaderLinks from "../components/Header/HeaderLinks.js";
import Parallax from "../components/Parallax/Parallax.js";
import SectionNavbars from "../pages-sections/Components-Sections/adviceDynamicSearch.js";
import logo from "../public/img/logo.png";

import styles from "../styles/jss/nextjs-material-kit/pages/articleStyle.js";

// Sections for this page
import ArticleList from "../pages-sections/ArticleList.js";
import PreFooter from "../pages-sections/LandingPage-Sections/PreFooter.js";
import JobsSidebar from "../pages-sections/JobsSidebar.js";
import Grid from "@mui/material/Grid";
import Head from "next/head";
import JSONSchemaData from "../components/JSONSchemaData/JSONSchemaData";

const dashboardRoutes = [];
const logoImg = "<img src=" + logo + "/>";

const useStyles = makeStyles()(styles);

export default function News(props) {
  const { classes, cx } = useStyles();
  const { ...rest } = props;

  const jsonBreadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://successatschool.org/"
    }, {
      "@type": "ListItem",
      "position": 2,
      "name": "News",
      "item": "https://successatschool.org/news"
    }]};

  return (
    <div className={cx(classes.white_bg, "employers")}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        logo={logo}
        rightLinks={<HeaderLinks />}
        fixed
        {...rest}
      />
      <Head>
        <link rel="canonical" href="https://successatschool.org/news" />
        <title>News - Success at School</title>
      </Head>
      <Parallax
        className="parallaxx-compact"
        filter
        image="/img/faces/company_advice_slide_bg.png"
      >
        <div className={cx(classes.container)}>
          <h1 className={cx(classes.title, "title")}>News</h1>
        </div>
      </Parallax>

      <div className={cx(classes.section, classes.white_bg, "jobbs")}>
        <div className={cx(classes.container)}>
          <Grid container justifyContent="space-between">
            <Grid item xs={12} sm={12} md={8}>
              <h1
                className={cx(
                  classes.title,
                  classes.cardTitle2
                )}
              >
                News
              </h1>

              {/* TODO We'll reinstate something like this dummy prototype of a filter area when offering CZ-filtered news lists. */}
              {/*<h4 className={classes.cardSubTitle}>*/}
              {/*  Professionals reveal what it's really like to do their job.*/}
              {/*</h4>*/}
              {/*<div*/}
              {/*  id="inputs"*/}
              {/*  className={[classes.search_section, "search_section"].join(" ")}*/}
              {/*  xs={12}*/}
              {/*  sm={4}*/}
              {/*  md={4}*/}
              {/*  lg={3}*/}
              {/*>*/}
              {/*  <GridContainer>*/}
              {/*    <SectionNavbars />*/}
              {/*  </GridContainer>*/}
              {/*</div>*/}
              {/*<div className={classes.space70} />*/}

              <ArticleList article_type='news' />
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <JobsSidebar />
            </Grid>
          </Grid>
        </div>
      </div>

      <div className={cx(classes.darkBlue, "footer", "colored_bgg")}>
        <PreFooter />
      </div>
      <Footer />
      <JSONSchemaData key_name={'breadcrumbSchema'} data={jsonBreadcrumbData} />
    </div>
  );
}
